import React from "react";
import { useQuery } from "react-query";
import StatCard from "../../../components/shared/StatCard";
import { formatCurrency } from "../../../utils/helpers";
import api from "../../../utils/api";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function AdminDashboard() {
  const { data: stats, isLoading } = useQuery("admin-stats", () =>
    api.get("/admin/stats")
  );

  const mockChartData = [
    { month: "Jan", bookings: 120, revenue: 45000 },
    { month: "Feb", bookings: 145, revenue: 52000 },
    { month: "Mar", bookings: 132, revenue: 49000 },
    { month: "Apr", bookings: 165, revenue: 63000 },
    { month: "May", bookings: 189, revenue: 71000 },
    { month: "Jun", bookings: 210, revenue: 85000 },
  ];

  return (
    <div className="space-y-6">
      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Total Patients"
          value={isLoading ? "…" : stats?.totalPatients ?? 1284}
          icon="🧑‍🤝‍🧑"
          color="primary"
          change="+12% this month"
          changeType="positive"
        />
        <StatCard
          title="Registered Doctors"
          value={isLoading ? "…" : stats?.totalDoctors ?? 87}
          icon="👨‍⚕️"
          color="success"
          change="+3 pending approval"
          changeType="neutral"
        />
        <StatCard
          title="Active Labs"
          value={isLoading ? "…" : stats?.totalLabs ?? 24}
          icon="🧪"
          color="purple"
        />
        <StatCard
          title="Revenue (Month)"
          value={isLoading ? "…" : formatCurrency(stats?.monthlyRevenue ?? 85000)}
          icon="💰"
          color="teal"
          change="+19% vs last month"
          changeType="positive"
        />
      </div>

      {/* Bookings Chart */}
      <div className="card">
        <h2 className="font-display font-semibold text-slate-800 mb-4">
          Bookings & Revenue Overview
        </h2>
        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={mockChartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="bookings"
              stroke="#0ea5e9"
              strokeWidth={2}
              dot={{ r: 4 }}
              name="Bookings"
            />
            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#14b8a6"
              strokeWidth={2}
              dot={{ r: 4 }}
              name="Revenue (₹)"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Quick Actions */}
      <div className="card">
        <h2 className="font-display font-semibold text-slate-800 mb-4">
          Pending Approvals
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { label: "Doctors awaiting approval", count: 3, path: "/admin/doctors", color: "bg-blue-50 border-blue-100" },
            { label: "Labs awaiting verification", count: 1, path: "/admin/labs", color: "bg-purple-50 border-purple-100" },
            { label: "Payment refund requests", count: 5, path: "/admin/payments", color: "bg-yellow-50 border-yellow-100" },
          ].map((item) => (
            <a
              key={item.label}
              href={item.path}
              className={`flex items-center justify-between p-4 rounded-xl border ${item.color} hover:shadow-sm transition-shadow`}
            >
              <span className="text-sm font-medium text-slate-700">
                {item.label}
              </span>
              <span className="font-display font-bold text-2xl text-slate-900">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
